import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // افزودن Link برای ثبت نام
import SanadForm2 from './SanadForm2';
import PrintFactor from './PrintFactor';
import '../../main.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault(); 

    if (!username || !password) {
      setError('لطفا نام کاربری و رمز عبور خود را وارد کنید.');
      return;
    }

    try {
      const response = await fetch('https://api.raynogroup.com/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('tokenhossein', data.token);
        window.alert('ورود با موفقیت انجام شد!');
        window.location.href = '/';
      } else {
        const errorData = await response.json();
        if (errorData.errors) {
          const errorMessages = errorData.errors.map(err => err.msg).join(', ');
          setError(errorMessages);
        }
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="container mt-5 mb-5">
    <div className="row justify-content-center">
      <div className="col-md-4">
        <div className="card shadow">
          <div className="card-body">
            <h5 className="text-center">ورود کاربر به سیستم:</h5>
            <form className='form-group my-3' onSubmit={handleSubmit}>
              <div className='mb-3'>
                <input
                  type="text"
                  placeholder="نام کاربری"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="form-control"
                />
              </div>
              <div className='mb-3'> 
                <input
                  type="password"
                  placeholder="رمز عبور"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-control"
                />
              </div>
              <button className='btn btn-primary shadow w-100' type="submit">ورود</button>
              {error && <div className="alert alert-danger mt-2">{error}</div>}
            </form>
            <div className="text-center mt-3">
              <Link to="/RegisterUser" className="text-primary">ثبت نام</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  );
}

export default Login;
